/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import { useQuery } from '@tanstack/react-query';
import { CalendarService } from '@services/requests/housien-services/CalendarService';
import type { Calendar } from '@services/requests/housien-models/Calendar';
import { agendaKeys } from './agenda-keys';

/**
 * List the agency calendars.
 * @param agencyId The agency id (query disabled when empty).
 */
export const useCalendars = (agencyId: string) =>
  useQuery<Calendar[]>({
    queryKey: agendaKeys.calendars(agencyId),
    queryFn: async () => {
      const response = await CalendarService.listCalendars(agencyId);
      return response.data ?? [];
    },
    enabled: Boolean(agencyId),
  });
